// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Icon_wrapper__RPTNb","xs":"Icon_xs__hBP_9","sm":"Icon_sm__7RWZ8","basic":"Icon_basic__m6vb1","md":"Icon_md__56mal","lg":"Icon_lg__mFOR9"};